import reminderCategories from '@db2b/keystone/store/modules/callcenter/reminder_categories'
import nexus from '@db2b/nexus-js'

reminderCategories.actions.load = ({state}) => {
  return nexus.get('callcenter', '/reminder_categories')
    .then(response => {
      state.all = response.data.data
    })
}

export default reminderCategories



// WEBPACK FOOTER //
// ./src/store/modules/reminder_categories.js